import { For, Show, type Component } from "solid-js";
import type { JSX } from "solid-js";
import type { DropdownConfig, NavLink } from "../navbarConfig";
// import { icons } from "../navbarIcons"; // Icons removed from dropdown links as per "should" image
import { classNames } from "@core/lib/classNames";
import styles from "./Navbar.module.css";
// import { HoverCard } from "@kobalte/core"; // Not used directly in content part

// Removed local SECTION_SUBTITLES, LINK_DESCRIPTIONS, and COMING_SOON_LINKS
// as this data now comes from navbarConfig.ts via props.config

interface PlatformDropdownProps {
  config: DropdownConfig;
}

export const PlatformDropdownContent: Component<PlatformDropdownProps> = (props) => {
  // Removed helper functions getSectionSubtitle, getLinkDescription, shouldShowComingSoon

  return (
    <div class={styles["header-hover-card-content"]}>
      <For each={props.config.sections}>
        {(section) => (
          // Using header-hover-card-content-column for consistency with module.css structure for columns
          <div class={styles["header-hover-card-content-column"]}>
            {/* dropdown-link-wrap for title/subtitle block */}
            <div class={styles["dropdown-link-wrap"]}>
              <h4
                class={classNames(
                  styles["text-size-small"],
                  styles["text-weight-semibold"],
                  styles["text-brand-purple-static"],
                )}
              >
                {section.title}
              </h4>
              {/* Use section.subtitle from config */}
              <Show when={section.subtitle}>
                <h4 class={classNames(styles["text-size-xsmall"], styles["text-style-muted"])}>{section.subtitle}</h4>
              </Show>
            </div>

            <div class={styles["spacer-tiny"]} />

            <For each={section.links}>
              {(link: NavLink) => (
                <a
                  href={link.href}
                  // Using header-hover-card-content-column-link for consistency
                  class={styles["header-hover-card-content-column-link"]}
                  tabIndex={0}
                >
                  {/* dropdown-link-wrap for link label/description block */}
                  <div class={styles["dropdown-link-wrap"]}>
                    <div class={styles["text-weight-medium"]}>
                      {link.label}
                      {/* Use link.isComingSoon from config */}
                      <Show when={link.isComingSoon}>
                        <span class={styles["span-coming-soon"]}>Coming Soon</span>
                      </Show>
                    </div>
                    {/* Use link.description from config */}
                    <Show when={link.description}>
                      <div class={classNames(styles["text-size-xsmall"], styles["text-style-muted"])}>
                        {link.description}
                      </div>
                    </Show>
                  </div>
                </a>
              )}
            </For>
          </div>
        )}
      </For>
    </div>
  );
};
